<style>
.align-cell-l {
  text-align: left !important;
}
.align-cell-r {
  text-align: right !important;
}
.align-cell-c {
  text-align: center !important;
}
.align-cell > div {
  display: inline-block;
  width: 100%;
}
</style>

<template>
  <component
    :is="tag"
    class="align-cell"
    :class="'align-cell-' + dir"
    v-on="$listeners"
    v-bind="$attrs"
    :style="{ width: width + 'px', minWidth: minWidth + 'px' }"
  >
    <div ref="div">
      <slot></slot>
    </div>
  </component>
</template>

<script>
import { calcWidth } from './utils'
export default {
  name: 'AlignCell',
  props: {
    dir: {
      type: String,
      default: 'l',
    },
    tag: {
      type: String,
      default: 'td',
    },
    width: {
      type: String,
    },
    minWidth: {
      type: String,
    },
  },
  data() {
    return {
      observer: undefined,
    }
  },
  async mounted() {
    if (!this.width && !this.minWidth) {
      this.calc()
      this.observer = new MutationObserver(this.calc)
      this.observer.observe(this.$refs.div, {
        childList: true,
        subtree: true,
        characterData: true,
      })
    } else if (this.width) {
      this.$refs.div.style.width = this.width + 'px'
    }
  },
  destroyed() {
    if (!this.width && !this.minWidth) {
      this.observer.disconnect()
    }
  },
  methods: {
    calc() {
      const table = this.$el.offsetParent
      if (!table) {
        return
      }
      const index = this.$el.cellIndex + 1
      const element = table.querySelectorAll(`.align-cell:nth-child(${index})>div`)
      //                // TODO
      this.$nextTick(() => {
        calcWidth(element)
      })
    },
  },
  computed: {
    hasDom() {
      return this.$slots.default
    },
  },
}
</script>
